<div class="page-content">
    <h3>{{tableText}}</h3>
    <div fxLayout="row" fxLayoutGap="50px">
      <mat-form-field style="width: 50%;">
        <input matInput (keyup)="onFilterTextChanged($event.target.value)" placeholder="{{'common.FilterByDescr' | translate}}">
      </mat-form-field>
      <button mat-raised-button color="primary" class="custom-button" [disabled]="!writeRight" (click)="createBaseTable()">{{newTableText}}</button>
    </div>
    <div class="mat-elevation-z8" [hidden]="numberOfRows == 0">
      <mat-table [dataSource]="basetables"
                 matSort (matSortChange)="loadData()"
                 matSortActive="{{defaultSortColumn}}" matSortDirection="{{defaultSortOrder}}">
        <ng-container matColumnDef="number">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.Number' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let baseTable"> {{baseTable.number}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.Descr' | translate}} </mat-header-cell>
          <mat-cell *matCellDef="let baseTable"> {{baseTable.description}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef fxFlex="120px">
          </mat-header-cell>
          <mat-cell *matCellDef="let baseTable" fxFlex="120px" fxFlexOffset="30px">
            <button mat-icon-button matTooltip="{{'common.Delete' | translate}}" [disabled]="!writeRight" (click)="$event.stopPropagation();confirmDelete(baseTable)">
              <mat-icon color="warn">delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"
                 (click)="editBaseTable(row)">
        </mat-row>
      </mat-table>
    </div>

    <mat-paginator [hidden]="numberOfRows < 11"
                   (page)="getData($event)"
                   [pageSize]="10"
                   [pageSizeOptions]="[10, 20, 50]"
                   showFirstLastButtons></mat-paginator>

</div>









